import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { ActivityMemoAction, ActivityMemoGetter } from '@/store/activityMemo/activityMemo.module';
import { ActivityAttachment, ActivityMemo } from '@/store/activityMemo/activityMemo.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ActivityAttachmentFileModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    activityId: {
      type: Number,
    },
    provinceId: {
      type: Number,
    },
    activityMemoId: {
      type: Number,
    }
  },
  emits: [
    'upload'
  ],
  setup: (props, context) => {
    const store = useStore();
    const swal = useSweetAlert();
    const activityMemo = computed<ActivityMemo | undefined>(() => store.getters[ActivityMemoGetter.BY_ID](props.activityMemoId));
    const documents = computed<ActivityAttachment[]>(() => (activityMemo.value?.result?.attachments) ? activityMemo.value?.result?.attachments.filter(m => m.attachmentType.id == 1) : []);
    const isLoading = computed(() => store.getters[ActivityMemoGetter.STATUS] === 'init' || store.getters[ActivityMemoGetter.STATUS] === 'loading');
    const activityAttachmentFileModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      activityAttachmentFileModal.value?.show();
    };

    // hide modal
    const hide = () => {
      activityAttachmentFileModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      hide();
      context.emit('upload');
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ActivityMemoAction.REMOVE_ATTACHMENTS, {
              activityId: props.activityId,
              provinceId: props.provinceId,
              id: props.activityMemoId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      activityMemo,
      documents,
      activityAttachmentFileModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
    };
  },
});
